const CLIENT_ID = "Iv23lir74knpYgJEkBiw";

const openGithubOAuth = () => {
  const authUrl = `https://github.com/login/oauth/authorize?client_id=${CLIENT_ID}`;
  const w = 600;
  const h = 700;
  const left = window.screenX + Math.max(0, (window.outerWidth - w) / 2);
  const top = window.screenY + Math.max(0, (window.outerHeight - h) / 2);
  const popup = window.open(
    authUrl,
    "github_oauth",
    `width=${w},height=${h},left=${left},top=${top}`
  );
  if (!popup) {
    throw new Error("弹窗被拦截，请允许弹窗后重试");
  }
  return popup;
};

const ensureAuthToken = async (): Promise<boolean> => {
  const existing = localStorage.getItem("jwtToken");
  if (existing) return true;

  // 开始 OAuth 流程
  const popup = openGithubOAuth();
  return new Promise((resolve) => {
    // 监测用户关闭弹窗的情况
    const timer = window.setInterval(() => {
      try {
        if (popup.closed) {
          window.clearInterval(timer);
          resolve(true);
        }
      } catch {
        // ignore
      }
    }, 800);
  });
};

export { openGithubOAuth, ensureAuthToken };
